var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 8.33325C11.3183 8.33325 8.3335 11.318 8.3335 14.9999C8.3335 18.6818 11.3183 21.6666 15.0002 21.6666C18.6821 21.6666 21.6668 18.6818 21.6668 14.9999C21.6668 11.318 18.6821 8.33325 15.0002 8.33325ZM15.0002 10.9999C17.2093 10.9999 19.0002 12.7908 19.0002 14.9999C19.0002 17.2091 17.2093 18.9999 15.0002 18.9999C12.791 18.9999 11.0002 17.2091 11.0002 14.9999C11.0002 12.7908 12.791 10.9999 15.0002 10.9999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3335 0.333252H17.6668C24.2942 0.333252 29.6668 5.70583 29.6668 12.3333V17.6666C29.6668 24.294 24.2942 29.6666 17.6668 29.6666H12.3335C5.70608 29.6666 0.333496 24.294 0.333496 17.6666V12.3333C0.333496 5.70583 5.70608 0.333252 12.3335 0.333252ZM17.6668 2.99992H12.3335C7.17884 2.99992 3.00016 7.17859 3.00016 12.3333V17.6666C3.00016 22.8212 7.17884 26.9999 12.3335 26.9999H17.6668C22.8215 26.9999 27.0002 22.8212 27.0002 17.6666V12.3333C27.0002 7.17859 22.8215 2.99992 17.6668 2.99992Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0002 8.33335C23.0002 9.06917 22.4025 9.66667 21.6665 9.66667C20.9304 9.66667 20.3335 9.06917 20.3335 8.33335C20.3335 7.5975 20.9304 7 21.6665 7C22.4025 7 23.0002 7.5975 23.0002 8.33335Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.564e72226067aa9128d9c952b02ca2c7.svg";
export { ForwardRef as ReactComponent };